import React from "react";
import PropTypes from "prop-types";
import {
  Summary,
  BlockContentContainer,
  BlockHeader,
  Label,
  StatusContainer,
  StatusInfo,
  StatusLabel,
  StatusDescription,
  Block
} from "./styles";
import FileList from "./FileList";
import CriteriaComponent from "./FeedInfoDetails/Criteria";
import {
  FEED_STATUSES_AS_DESCRIPTIONS,
  FEED_STATUSES_AS_LABELS,
  selectIconByStatus
} from "../../../constants";
import { SUMMARY, FILES, CRITERIA } from "..";

const FeedInfo = ({ activeTab, feed, files }) => {
  if (activeTab === SUMMARY) {
    return (
      <Summary>
        <Block>
          <BlockContentContainer>
            <BlockHeader>
              <Label>STATUS</Label>
            </BlockHeader>
            <StatusContainer>
              <StatusInfo>
                {selectIconByStatus(feed.status)}
                <StatusLabel>
                  {FEED_STATUSES_AS_LABELS[feed.status]}
                </StatusLabel>
              </StatusInfo>
              <StatusDescription>
                {FEED_STATUSES_AS_DESCRIPTIONS[feed.status]}
              </StatusDescription>
            </StatusContainer>
          </BlockContentContainer>
        </Block>
        <Block>
          <BlockContentContainer>
            <BlockHeader>
              <Label>LATEST FILE</Label>
            </BlockHeader>
            <FileList feed={feed} files={files.slice(0, 1)} />
          </BlockContentContainer>
        </Block>
      </Summary>
    );
  }

  if (activeTab === FILES) {
    return (
      <Block>
        <BlockContentContainer>
          <FileList feed={feed} files={files} />
        </BlockContentContainer>
      </Block>
    );
  }

  if (activeTab === CRITERIA) {
    return <CriteriaComponent feed={feed} files={files} />;
  }
};

FeedInfo.propTypes = {
  activeTab: PropTypes.string,
  feed: PropTypes.shape({
    id: PropTypes.number,
    client_id: PropTypes.number,
    created_at: PropTypes.string,
    delivery_schedule: PropTypes.string,
    kantar_filter_expression: PropTypes.shape({
      brand: PropTypes.arrayOf(PropTypes.string)
    }),
    name: PropTypes.string,
    pdp_infomediary: PropTypes.string,
    progress_ids: PropTypes.arrayOf(PropTypes.string),
    quality_metrics: PropTypes.shape({
      final_rowcount: PropTypes.number
    }),
    service_start: PropTypes.string,
    status: PropTypes.string,
    updated_at: PropTypes.string,
    file_columns: PropTypes.array
  }),
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string,
      report_id: PropTypes.number,
      progressing: PropTypes.bool,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      row_cnt: PropTypes.string,
      device_cnt: PropTypes.string,
      network_cnt: PropTypes.string,
      airing_cnt: PropTypes.string,
      brand_cnt: PropTypes.string,
      sla_violation: PropTypes.bool
    })
  )
};

export default FeedInfo;
